import React, {FC} from 'react';
import {withStyles} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

const Title = withStyles(theme => ({
    root: {
        marginBottom: theme.spacing(1)
    }
}))(Typography);

export interface GameInfoProps {
    title: string;
    code?: string;
}

const GameInfo: FC<GameInfoProps> = ({title, code}: GameInfoProps) => {
    return (
        <>
            <Title color="textPrimary">{title}</Title>
            {code && (
                <Typography color="textSecondary" variant="caption">
                    {code}
                </Typography>
            )}
        </>
    );
};

export default GameInfo;
